import { api } from '../axios'
import type { ApiResponse } from '../../../types'

export const appointmentTypesApi = {
  getAll: () =>
    api.get<ApiResponse<any[]>>('/appointment-types'),

  getActive: () =>
    api.get<ApiResponse<any[]>>('/appointment-types/active'),

  getById: (id: number) =>
    api.get<ApiResponse<any>>(`/appointment-types/${id}`),

  create: (data: { name: string, is_active?: boolean }) =>
    api.post<ApiResponse<any>>('/appointment-types', data),

  update: (id: number, data: { name: string, is_active?: boolean }) =>
    api.put<ApiResponse<any>>(`/appointment-types/${id}`, data),

  delete: (id: number) =>
    api.delete<ApiResponse>(`/appointment-types/${id}`),

  hardDelete: (id: number) =>
    api.delete<ApiResponse>(`/appointment-types/${id}/permanent`),

  // Appointment type change audit history for a teacher
  getHistoryByTeacherId: (teacherId: number) =>
    api.get<ApiResponse<any[]>>(`/appointment-types/history/${teacherId}`),
}

